import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService } from 'primeng/api';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { CompetenceModel } from 'projects/core/src/lib/models/competence.model';

@Component({
  selector: 'app-competence-basedata',
  templateUrl: './competence-basedata.component.html',
  styleUrls: ['./competence-basedata.component.scss']
})
export class CompetenceBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @Input() competence: CompetenceModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public form = this.fb.group({
    name_de: new UntypedFormControl('', [Validators.required]),
    name_en: new UntypedFormControl('', [Validators.required])
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    if (this.competence !== null && this.auth.hasRight('admin.competence.delete')) {
      this.items.push({
        label: this.transloco.translate('common.labels.delete'),
        icon: 'pi pi-trash',
        styleClass: 'danger-button',
        disabled: (!this.competence.deletable),
        command: () => {
          this.onDelete();
        }
      });
    }
  }

  onEdit(): void {
    if (this.auth.hasRight('admin.competence.edit')) {
      this.startEdit();
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('competences', this.competence.id, this.form.value).subscribe({
        next: (result: any) => {
          this.competence.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.competence.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onDelete(): void {
    if (this.auth.hasRight('admin.competence.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: this.competence.getLang('name', this.transloco.getActiveLang())  }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.deleteModel('competences', this.competence.id).subscribe({
            next: () => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.competence.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.deleted'));
              this.router.navigate(['/competences']);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  protected startEdit(): void {
    if (this.competence !== null) {
      this.form.patchValue({
        name_de: this.competence.getLang('name', 'DE'),
        name_en: this.competence.getLang('name', 'EN')
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

}
